const BooleanService = {
    splitToBooleanArray : (input, length) => {
        // Parse and convert to boolean array
        const normalizedInput = input ? String(input) : "";
        const numbers = normalizedInput.split(',')
            .map(Number)
            .filter(n => !isNaN(n) && n >= 1 && n <= length);

        // Initialize array with false values
        const result = new Array(length).fill(false);

        // Set true for existing numbers
        numbers.forEach(n => {
            result[n-1] = true;
        });

        return result;
    },

    toCommaSeparated : (booleanArray) => {
        return booleanArray
            .map((val, index) => val ? index + 1 : null)
            .filter(val => val !== null)
            .join(',');
    },

    // UI weekly array is Monday-first: [Mon, Tue, Wed, Thu, Fri, Sat, Sun]
    // Backend selectedIndex uses Calendar.DAY_OF_WEEK values: 1=Sun ... 7=Sat.
    splitWeeklyCalendarDowToBooleanArray : (input) => {
        const normalizedInput = input ? String(input) : "";
        const numbers = normalizedInput.split(',')
            .map(Number)
            .filter(n => !isNaN(n) && n >= 1 && n <= 7);
        const result = new Array(7).fill(false);
        numbers.forEach((calendarDow) => {
            const uiIndex = calendarDow === 1 ? 6 : calendarDow - 2;
            result[uiIndex] = true;
        });
        return result;
    },

    toWeeklyCalendarDowCommaSeparated : (booleanArray) => {
        return booleanArray
            .map((val, index) => {
                if (!val) {
                    return null;
                }
                return index === 6 ? 1 : index + 2;
            })
            .filter(val => val !== null)
            .join(',');
    }
}

export default BooleanService